// extracted by mini-css-extract-plugin
export var brandHeader = "_redotech-redo-customer-portal-app-lib-portal-four-returns-components-dropoffs-happy-returns-confirmation-card-brand-header";